export const isPartOf = <T extends string>(key: string, allowedValues: readonly T[]): key is T  => allowedValues.includes(key as T);
